import {
    omit
} from 'lodash';
import {
    AGE_RANGES,
    BETTER_DRINKERS_CHALLENGES,
    CONCERN_LEVELS,
    DiagnosticAnswers,
    DRY_JAN_2026_CHALLENGES,
    DRY_JAN_CHALLENGES,
    EFFECT_FREQUENCIES,
    END_GOALS,
    FOCUS_AREAS,
    GENDER_CHOICES,
    GOAL_CHOICES,
    MED_FIRST_GOAL_CHOICES,
    PRONOUN_CHOICES,
    SOBERISH_MOM_CHALLENGES,
    SOBERISH_MOM_DRYJAN_2026_CHALLENGES,
    SOBERISH_MOM_DRYJAN_CHALLENGES,
    SOBERISH_OCTOBER_2025_CHALLENGES,
    ZUMBA_CHALLENGES
} from './types';
import {
    DiagnosticFormContextValue,
    FormContextValue,
    MATFormContextValue,
    MedFirstDiagnosticFormContextValue
} from '../../../contexts/form';
import {
    get,
    post
} from '../../../networking';
import {
    gaClientEvent
} from '../../../lib/tracking/gtag';
import {
    ampIdentifySetMultiple, ampLogEvent
} from '../../../lib/amplitude';
import metaEvent, {
    MetaTrackingEventName,
    MetaTrackingTypeEnum
} from '../../../lib/tracking/meta';
import {
    finalizeAnswerPayload,
    finalizePayload,
    MATIntakeAnswers
} from './mat-types';
import {
    NextRouter
} from 'next/router';
import {
    Dispatch
} from 'react';
import dataDogLogger from '../../../lib/datadog';
import {
    activeFormId,
    genericSunnysideMedDiagnosticFormId,
    glp1DiagnosticFormId,
    naltrexoneOnlyDiagnosticFormId,
    naltrexoneOnlyV2DiagnosticFormId,
    naltrexoneFirstV2RecommendationDiagnosticFormId,
    naltrexoneV2RecommendationDiagnosticFormId,
    genericAdSafeSunnysideMedDiagnosticFormId,
    naltrexoneOnlyRefillFormId,
    naltrexoneOnlyV2RefillFormId,
    glp1RefillFormId
} from '../../../logic/auth';
import spacetime from 'spacetime';
import {
    REFILL_BUFFER_DAY_COUNT, REFILL_RENEWAL_WINDOW_DAY_COUNT
} from './constants';
import {
    StripeProviderEnum
} from '../../../utils/payments/types/stripe.type';
import {
    PlanKeyEnum
} from '../../../utils/payments/types/payments.type';
import tiktokEvent, { TikTokEvent, TiktokPixelAudience } from '../../../lib/tracking/tiktok';
import { getCurrentUrlPath, getReferrerPath } from '../../../lib/tracking/utils';
import { FlowType } from '../../start/flow-type.enum';
import { mapFormIdToOpenloopFormId } from '../../../utils/medication/formId';
import theme from '../../../figmaTheme';

export const createIntroSkip = (diagnosticFormContext: DiagnosticFormContextValue, jump: number) => {
    return () => {
        const baselines = [
            Math.floor(Math.random() * 10),
            Math.floor(Math.random() * 10),
            Math.floor(Math.random() * 10),
            Math.floor(Math.random() * 10),
            Math.floor(Math.random() * 10),
            Math.floor(Math.random() * 10),
            Math.floor(Math.random() * 10)
        ];
        const totalDrinks = baselines.reduce((acc, curr) => acc + curr, 0);
        const totalDryDays = baselines.filter(baseline => baseline === 0).length;
        const top_goal = GOAL_CHOICES[Math.floor(Math.random() * 10)].key;
        const customTargets = Math.random() > 0.5 ? 'true' : 'false';

        const other_goals = [top_goal];
        let goalChoices = GOAL_CHOICES.map(({
            key
        }) => key).filter(goal => goal !== top_goal);
        const numGoals = Math.floor(Math.random() * 10);
        for (let i = 0; i < numGoals; i++) {
            const goal = goalChoices[Math.floor(Math.random() * goalChoices.length)];
            goalChoices = goalChoices.filter(g => g !== goal);
            other_goals.push(goal);
        }

        const focus_areas = [];
        let focusAreas = FOCUS_AREAS.map(({
            key
        }) => key);
        const numFocusAreas = Math.floor(Math.random() * 4);
        for (let i = 0; i < numFocusAreas; i++) {
            const area = focusAreas[Math.floor(Math.random() * focusAreas.length)];
            focusAreas = focusAreas.filter(a => a !== area);
            focus_areas.push(area);
        }

        diagnosticFormContext.setAnswers({
            top_goal,
            other_goals,
            endGoal: END_GOALS[Math.floor(Math.random() * 3)].key,
            your_name: 'Skippy',
            totalDrinksBaseline: totalDrinks,
            totalDryDaysBaseline: totalDryDays,
            mon_baseline: baselines[0],
            tue_baseline: baselines[1],
            wed_baseline: baselines[2],
            thu_baseline: baselines[3],
            fri_baseline: baselines[4],
            sat_baseline: baselines[5],
            sun_baseline: baselines[6],
            drinkCost: Math.floor(Math.random() * 5) + 5,
            freq_of_effects: EFFECT_FREQUENCIES[Math.floor(Math.random() * 5)].key,
            concern_level: CONCERN_LEVELS[Math.floor(Math.random() * 5)].key,
            customTargets,
            focus_areas,
            targetTotalDrinks: Math.floor(Math.random() * (totalDrinks - 1)),
            targetTotalDryDays: totalDryDays === 7 ? totalDryDays + 1 : totalDryDays,
        });

        diagnosticFormContext.goNext(jump);
    };
};

export const createGoalsSkip = (diagnosticFormContext: DiagnosticFormContextValue, jump: number) => {
    return () => {
        const baselines = [
            Math.floor(Math.random() * 10),
            Math.floor(Math.random() * 10),
            Math.floor(Math.random() * 10),
            Math.floor(Math.random() * 10),
            Math.floor(Math.random() * 10),
            Math.floor(Math.random() * 10),
            Math.floor(Math.random() * 10)
        ];
        const totalDrinks = baselines.reduce((acc, curr) => acc + curr, 0);
        const totalDryDays = baselines.filter(baseline => baseline === 0).length;
        const top_goal = GOAL_CHOICES[Math.floor(Math.random() * 10)].key;
        const customTargets = Math.random() > 0.5 ? 'true' : 'false';

        const other_goals = [top_goal];
        let goalChoices = GOAL_CHOICES.map(({
            key
        }) => key).filter(goal => goal !== top_goal);
        const numGoals = Math.floor(Math.random() * 10);
        for (let i = 0; i < numGoals; i++) {
            const goal = goalChoices[Math.floor(Math.random() * goalChoices.length)];
            goalChoices = goalChoices.filter(g => g !== goal);
            other_goals.push(goal);
        }

        const focus_areas = [];
        let focusAreas = FOCUS_AREAS.map(({
            key
        }) => key);
        const numFocusAreas = Math.floor(Math.random() * 4);
        for (let i = 0; i < numFocusAreas; i++) {
            const area = focusAreas[Math.floor(Math.random() * focusAreas.length)];
            focusAreas = focusAreas.filter(a => a !== area);
            focus_areas.push(area);
        }

        diagnosticFormContext.setAnswers({
            top_goal,
            other_goals,
            endGoal: END_GOALS[Math.floor(Math.random() * 3)].key,
            your_name: 'Skippy',
            totalDrinksBaseline: totalDrinks,
            totalDryDaysBaseline: totalDryDays,
            mon_baseline: baselines[0],
            tue_baseline: baselines[1],
            wed_baseline: baselines[2],
            thu_baseline: baselines[3],
            fri_baseline: baselines[4],
            sat_baseline: baselines[5],
            sun_baseline: baselines[6],
            drinkCost: Math.floor(Math.random() * 5) + 5,
            freq_of_effects: EFFECT_FREQUENCIES[Math.floor(Math.random() * 5)].key,
            concern_level: CONCERN_LEVELS[Math.floor(Math.random() * 5)].key,
            customTargets,
            focus_areas,
            targetTotalDrinks: Math.floor(Math.random() * (totalDrinks - 1)),
            targetTotalDryDays: totalDryDays === 7 ? totalDryDays + 1 : totalDryDays,
            gender: GENDER_CHOICES[Math.floor(Math.random() * 4)].key,
            age_range: AGE_RANGES[Math.floor(Math.random() * 8)].key,
            pronouns: PRONOUN_CHOICES[Math.floor(Math.random() * 5)].key,
            caloriesAvoided: '83k',
            dollarsSaved: '$5.3k',
            extraNightsOfSleep: '+169'
        });

        diagnosticFormContext.goNext(jump);
    };
};

export const createNameSkip = (diagnosticFormContext: DiagnosticFormContextValue, jump: number) => {
    return () => {
        const baselines = [
            Math.floor(Math.random() * 10),
            Math.floor(Math.random() * 10),
            Math.floor(Math.random() * 10),
            Math.floor(Math.random() * 10),
            Math.floor(Math.random() * 10),
            Math.floor(Math.random() * 10),
            Math.floor(Math.random() * 10)
        ];
        const totalDrinks = baselines.reduce((acc, curr) => acc + curr, 0);
        const totalDryDays = baselines.filter(baseline => baseline === 0).length;
        const top_goal = GOAL_CHOICES[Math.floor(Math.random() * 10)].key;
        const customTargets = Math.random() > 0.5 ? 'true' : 'false';

        const other_goals = [top_goal];
        let goalChoices = GOAL_CHOICES.map(({
            key
        }) => key).filter(goal => goal !== top_goal);
        const numGoals = Math.floor(Math.random() * 10);
        for (let i = 0; i < numGoals; i++) {
            const goal = goalChoices[Math.floor(Math.random() * goalChoices.length)];
            goalChoices = goalChoices.filter(g => g !== goal);
            other_goals.push(goal);
        }

        const focus_areas = [];
        let focusAreas = FOCUS_AREAS.map(({
            key
        }) => key);
        const numFocusAreas = Math.floor(Math.random() * 4);
        for (let i = 0; i < numFocusAreas; i++) {
            const area = focusAreas[Math.floor(Math.random() * focusAreas.length)];
            focusAreas = focusAreas.filter(a => a !== area);
            focus_areas.push(area);
        }

        diagnosticFormContext.setAnswers({
            top_goal,
            other_goals,
            endGoal: END_GOALS[Math.floor(Math.random() * 3)].key,
            your_name: 'Skippy',
            totalDrinksBaseline: totalDrinks,
            totalDryDaysBaseline: totalDryDays,
            mon_baseline: baselines[0],
            tue_baseline: baselines[1],
            wed_baseline: baselines[2],
            thu_baseline: baselines[3],
            fri_baseline: baselines[4],
            sat_baseline: baselines[5],
            sun_baseline: baselines[6],
            drinkCost: Math.floor(Math.random() * 5) + 5,
            freq_of_effects: EFFECT_FREQUENCIES[Math.floor(Math.random() * 5)].key,
            concern_level: CONCERN_LEVELS[Math.floor(Math.random() * 5)].key,
            customTargets,
            focus_areas,
            targetTotalDrinks: Math.floor(Math.random() * (totalDrinks - 1)),
            targetTotalDryDays: totalDryDays === 7 ? totalDryDays + 1 : totalDryDays,
        });

        diagnosticFormContext.goNext(jump);
    };
};

export const createEmailSkip = (diagnosticFormContext: DiagnosticFormContextValue, jump: number) => {
    return (partialAnswers: any) => {
        const answers = Object.assign({
            gender: GENDER_CHOICES[Math.floor(Math.random() * 4)].key,
            age_range: AGE_RANGES[Math.floor(Math.random() * 8)].key,
            pronouns: PRONOUN_CHOICES[Math.floor(Math.random() * 5)].key,
            caloriesAvoided: '83k',
            dollarsSaved: '$5.3k',
            extraNightsOfSleep: '+169'
        }, partialAnswers);

        diagnosticFormContext.setAnswers(answers);

        diagnosticFormContext.goNext(jump);
    };
};

export const createPhoneSkip = (diagnosticFormContext: DiagnosticFormContextValue, jump: number) => {
    return () => {
        diagnosticFormContext.goNext(jump);
    };
};

export const createDiagnosticComplete = (
    diagnosticFormContext: DiagnosticFormContextValue,
    cookies: any,
    user: any,
    callback?: any
) => {
    return async () => {
        await post('forms/partial-answer', {
            formId: diagnosticFormContext.formId,
            ref: 'timezone',
            value: Intl.DateTimeFormat().resolvedOptions().timeZone
        }).then(async () => {
            gaClientEvent({
                action: 'Land',
                category: 'Page',
                label: 'signup: completed wizard',
                value: '',
            });

            ampLogEvent(
                'signup: completed wizard',
                {
                    formId: diagnosticFormContext.formId,
                },
                cookies
            );

            const answers = diagnosticFormContext.answers;
            let diag_starting_drink_level = '';
            if (answers.totalDrinksBaseline < 5) {
                diag_starting_drink_level = '0-4';
            } else if (answers.totalDrinksBaseline > 4 && answers.totalDrinksBaseline < 10) {
                diag_starting_drink_level = '5-9';
            } else if (answers.totalDrinksBaseline > 9 && answers.totalDrinksBaseline < 15) {
                diag_starting_drink_level = '10-14';
            } else if (answers.totalDrinksBaseline > 14 && answers.totalDrinksBaseline < 20) {
                diag_starting_drink_level = '15-19';
            } else if (answers.totalDrinksBaseline > 19 && answers.totalDrinksBaseline < 25) {
                diag_starting_drink_level = '20-24';
            } else if (answers.totalDrinksBaseline > 24 && answers.totalDrinksBaseline < 30) {
                diag_starting_drink_level = '25-29';
            } else if (answers.totalDrinksBaseline > 29 && answers.totalDrinksBaseline < 35) {
                diag_starting_drink_level = '30-34';
            } else if (answers.totalDrinksBaseline > 34 && answers.totalDrinksBaseline < 40) {
                diag_starting_drink_level = '35-39';
            } else if (answers.totalDrinksBaseline > 39 && answers.totalDrinksBaseline < 45) {
                diag_starting_drink_level = '40-44';
            } else if (answers.totalDrinksBaseline > 44 && answers.totalDrinksBaseline < 50) {
                diag_starting_drink_level = '45-49';
            } else if (answers.totalDrinksBaseline > 49) {
                diag_starting_drink_level = '50+';
            }

            let top = 'other';
            if (answers.top_goal === 'health') {
                top = 'overall_health';
            } else if (answers.top_goal === 'healthspan') {
                top = 'health_span';
            } else if (answers.top_goal === 'emotions') {
                top = 'emotional_coping';
            } else if (answers.top_goal === 'relationships') {
                top = 'improve_relationships';
            } else if (answers.top_goal === 'stress') {
                top = 'reduce_stress';
            } else if (answers.top_goal === 'weight') {
                top = 'lose_weight';
            } else if (answers.top_goal === 'sleep') {
                top = 'improve_sleep';
            } else if (answers.top_goal === 'money') {
                top = 'save_money';
            } else if (answers.top_goal === 'hangover') {
                top = 'avoid_hangovers';
            } else if (answers.top_goal === 'blackout') {
                top = 'stop_blackouts';
            }

            let frequency = 'other';
            if (answers.freq_of_effects === 'Daily or almost daily') {
                frequency = 'daily';
            } else if (answers.freq_of_effects === '1-2 times per month') {
                frequency = '1-2_per_month';
            } else if (answers.freq_of_effects === '1-2 times per week') {
                frequency = '1-2_per_week';
            } else if (answers.freq_of_effects === '2-4 times per week') {
                frequency = '2-4_per_week';
            } else if (answers.freq_of_effects === 'Less than once a month') {
                frequency = 'less_than_monthly';
            }

            let endGoal = 'other';
            if (answers.endGoal === 'Drink Less') {
                endGoal = 'drink_less';
            } else if (answers.endGoal === 'Complete Zero') {
                endGoal = 'complete_zero';
            } else if (answers.endGoal === 'Not Sure') {
                endGoal = 'not_sure';
            }

            ampIdentifySetMultiple([
                {
                    key: 'diag_concern_level',
                    value: answers?.concern_level?.toString()
                },
                {
                    key: 'diag_total_drink_baseline',
                    value: answers?.totalDrinksBaseline?.toString()
                },
                {
                    key: 'diag_dry_days_baseline',
                    value: answers?.totalDryDaysBaseline?.toString()
                },
                {
                    key: 'diag_target_drinks',
                    value: answers?.targetTotalDrinks?.toString()
                },
                {
                    key: 'diag_target_dry_days',
                    value: answers?.targetTotalDryDays?.toString()
                },
                {
                    key: 'diag_top_goal',
                    value: top
                },
                {
                    key: 'diag_freq_of_effects',
                    value: frequency
                },
                {
                    key: 'gender',
                    value: answers?.gender
                },
                {
                    key: 'starting_drink_range',
                    value: diag_starting_drink_level
                },
                {
                    key: 'diag_age_range',
                    value: answers?.age_range
                },
                {
                    key: 'diag_end_goal',
                    value: endGoal
                },
                {
                    key: 'diag_custom_targets',
                    value: answers?.customTargets
                }
            ]);

            ampLogEvent('signup: diagnostic responses processed', {}, cookies);

            await post('diagnostic/finalize', {
                formId: diagnosticFormContext.formId
            });
            if (user.id && cookies) {
                metaEvent({
                    event_name: MetaTrackingEventName.COMPLETE_REGISTRATION,
                    user,
                    url: `https://app.sunnyside.co/diagnostic/${diagnosticFormContext.formId || activeFormId}/${diagnosticFormContext.screenIndex || 0}`,
                    cookies,
                    custom_data: null,
                    trackingType: MetaTrackingTypeEnum.TRACK_SINGLE
                });
            }

            if (callback) callback();
        }).finally(() => {
            if (cookies?.ss_app === 'true') {
                let hyperlink = 'https://app.sunnyside.co/app-bridge';
                switch (process.env.NEXT_PUBLIC_NENV) {
                case 'development':
                    hyperlink = 'http://app.dev.sunnyside.co/app-bridge';
                    break;
                case 'staging':
                    hyperlink = 'https://app.staging.sunnyside.co/app-bridge';
                    break;
                }
                setTimeout(() => {
                    window.location.href = hyperlink;
                }, 0);
            } else {
                diagnosticFormContext.goNext();
            }
        });
    };
};

export const convertRetrievedAnswers = (retrievedAnswers: any = {}) => {
    const convertedAnswers: DiagnosticAnswers = {};

    if (retrievedAnswers.gender) convertedAnswers.gender = retrievedAnswers.gender.label;
    if (retrievedAnswers.age_range) convertedAnswers.age_range = retrievedAnswers.age_range.label;
    if (retrievedAnswers.top_goal) convertedAnswers.top_goal = GOAL_CHOICES.find(goal => goal.legacyTitle === retrievedAnswers.top_goal.label)?.key;
    if (retrievedAnswers.freq_of_effects) convertedAnswers.freq_of_effects = EFFECT_FREQUENCIES.find(freq => freq.subtitle === retrievedAnswers.freq_of_effects.label)?.key;
    if (retrievedAnswers.other_goals) {
        convertedAnswers.other_goals = Object.keys(retrievedAnswers.other_goals).filter(key => retrievedAnswers.other_goals[key].selected).map(key => GOAL_CHOICES.find(({
            legacyTitle
        }) => legacyTitle === retrievedAnswers.other_goals[key].label)?.key);
        convertedAnswers.other_goals.push(convertedAnswers.top_goal);
    }
    if (retrievedAnswers.focus_areas) convertedAnswers.focus_areas = Object.keys(retrievedAnswers.focus_areas).filter(key => retrievedAnswers.focus_areas[key].selected).map(key => FOCUS_AREAS.find(({
        title, subtitle
    }) => retrievedAnswers.focus_areas[key].label.replace(/\./g, '') === `${title}: ${subtitle}`.replace(/\./g, ''))?.key);
    if (retrievedAnswers.your_name) convertedAnswers.your_name = retrievedAnswers.your_name;
    if (retrievedAnswers.email) convertedAnswers.email = retrievedAnswers.email;
    if (retrievedAnswers.customTargets) convertedAnswers.customTargets = retrievedAnswers.customTargets;
    if ('mon_baseline' in retrievedAnswers) convertedAnswers.mon_baseline = retrievedAnswers.mon_baseline;
    if ('tue_baseline' in retrievedAnswers) convertedAnswers.tue_baseline = retrievedAnswers.tue_baseline;
    if ('wed_baseline' in retrievedAnswers) convertedAnswers.wed_baseline = retrievedAnswers.wed_baseline;
    if ('thu_baseline' in retrievedAnswers) convertedAnswers.thu_baseline = retrievedAnswers.thu_baseline;
    if ('fri_baseline' in retrievedAnswers) convertedAnswers.fri_baseline = retrievedAnswers.fri_baseline;
    if ('sat_baseline' in retrievedAnswers) convertedAnswers.sat_baseline = retrievedAnswers.sat_baseline;
    if ('sun_baseline' in retrievedAnswers) convertedAnswers.sun_baseline = retrievedAnswers.sun_baseline;
    if ('totalDrinksBaseline' in retrievedAnswers) convertedAnswers.totalDrinksBaseline = retrievedAnswers.totalDrinksBaseline;
    if ('totalDryDaysBaseline' in retrievedAnswers) convertedAnswers.totalDryDaysBaseline = retrievedAnswers.totalDryDaysBaseline;
    if ('drinkCost' in retrievedAnswers) convertedAnswers.drinkCost = retrievedAnswers.drinkCost;
    if ('concern_level' in retrievedAnswers) convertedAnswers.concern_level = retrievedAnswers.concern_level;
    if ('targetTotalDrinks' in retrievedAnswers) convertedAnswers.targetTotalDrinks = retrievedAnswers.targetTotalDrinks;
    if ('targetTotalDryDays' in retrievedAnswers) convertedAnswers.targetTotalDryDays = retrievedAnswers.targetTotalDryDays;
    if (retrievedAnswers.pronouns) convertedAnswers.pronouns = retrievedAnswers.pronouns;
    if (retrievedAnswers.endGoal) convertedAnswers.endGoal = retrievedAnswers.endGoal;
    if (retrievedAnswers.caloriesAvoided) convertedAnswers.caloriesAvoided = retrievedAnswers.caloriesAvoided;
    if (retrievedAnswers.dollarsSaved) convertedAnswers.dollarsSaved = retrievedAnswers.dollarsSaved;
    if (retrievedAnswers.extraNightsOfSleep) convertedAnswers.extraNightsOfSleep = retrievedAnswers.extraNightsOfSleep;
    if (retrievedAnswers['abcfitnessdryjanuary-2025-challenge_identifier']) convertedAnswers['abcfitnessdryjanuary-2025-challenge_identifier'] = retrievedAnswers['abcfitnessdryjanuary-2025-challenge_identifier'].value;
    if (retrievedAnswers['dryish-january-2025-challenge_identifier']) convertedAnswers['dryish-january-2025-challenge_identifier'] = retrievedAnswers['dryish-january-2025-challenge_identifier'].value;
    if (retrievedAnswers['dryish-january-2026-challenge_identifier']) convertedAnswers['dryish-january-2026-challenge_identifier'] = retrievedAnswers['dryish-january-2026-challenge_identifier'].value;
    if (retrievedAnswers['soberishmom-dryjan-2025-challenge_identifier']) convertedAnswers['soberishmom-dryjan-2025-challenge_identifier'] = retrievedAnswers['soberishmom-dryjan-2025-challenge_identifier'].value;
    if (retrievedAnswers['soberishmom-dryjan-2026-challenge_identifier']) convertedAnswers['soberishmom-dryjan-2026-challenge_identifier'] = retrievedAnswers['soberishmom-dryjan-2026-challenge_identifier'].value;
    if (retrievedAnswers['soberishmom-challenge_identifier']) convertedAnswers['soberishmom-challenge_identifier'] = retrievedAnswers['soberishmom-challenge_identifier'].value;
    if (retrievedAnswers['ucbdryjanuary-2025-challenge_identifier']) convertedAnswers['ucbdryjanuary-2025-challenge_identifier'] = retrievedAnswers['ucbdryjanuary-2025-challenge_identifier'].value;
    if (retrievedAnswers['zumba-2025-04-challenge_identifier']) convertedAnswers['zumba-2025-04-challenge_identifier'] = retrievedAnswers['zumba-2025-04-challenge_identifier'].value;
    if (retrievedAnswers['better-drinkers-2025-challenge_identifier']) convertedAnswers['better-drinkers-2025-challenge_identifier'] = retrievedAnswers['better-drinkers-2025-challenge_identifier'].value;
    if (retrievedAnswers['soberish-october-2025-challenge_identifier']) convertedAnswers['soberish-october-2025-challenge_identifier'] = retrievedAnswers['soberish-october-2025-challenge_identifier'].value;

    return convertedAnswers;
};

export const convertRetrievedMedAnswers = (retrievedAnswers: any = {}) => {
    const convertedAnswers: DiagnosticAnswers = {};

    if (retrievedAnswers.gender) convertedAnswers.gender = retrievedAnswers.gender.label;
    if (retrievedAnswers.age_range) convertedAnswers.age_range = retrievedAnswers.age_range.label;
    if (retrievedAnswers.top_goal) convertedAnswers.top_goal = MED_FIRST_GOAL_CHOICES.find(goal => goal.legacyTitle === retrievedAnswers.top_goal.label)?.key;
    if (retrievedAnswers.freq_of_effects) convertedAnswers.freq_of_effects = EFFECT_FREQUENCIES.find(freq => freq.subtitle === retrievedAnswers.freq_of_effects.label)?.key;
    if (retrievedAnswers.other_goals) {
        convertedAnswers.other_goals = Object.keys(retrievedAnswers.other_goals).filter(key => retrievedAnswers.other_goals[key].selected).map(key => MED_FIRST_GOAL_CHOICES.find(({
            legacyTitle
        }) => legacyTitle === retrievedAnswers.other_goals[key].label)?.key);
        convertedAnswers.other_goals.push(convertedAnswers.top_goal);
    }
    if (retrievedAnswers.focus_areas) convertedAnswers.focus_areas = Object.keys(retrievedAnswers.focus_areas).filter(key => retrievedAnswers.focus_areas[key].selected).map(key => FOCUS_AREAS.find(({
        title, subtitle
    }) => retrievedAnswers.focus_areas[key].label.replace(/\./g, '') === `${title}: ${subtitle}`.replace(/\./g, ''))?.key);
    if (retrievedAnswers.your_name) convertedAnswers.your_name = retrievedAnswers.your_name;
    if (retrievedAnswers.email) convertedAnswers.email = retrievedAnswers.email;
    if (retrievedAnswers.customTargets) convertedAnswers.customTargets = retrievedAnswers.customTargets;
    if ('mon_baseline' in retrievedAnswers) convertedAnswers.mon_baseline = retrievedAnswers.mon_baseline;
    if ('tue_baseline' in retrievedAnswers) convertedAnswers.tue_baseline = retrievedAnswers.tue_baseline;
    if ('wed_baseline' in retrievedAnswers) convertedAnswers.wed_baseline = retrievedAnswers.wed_baseline;
    if ('thu_baseline' in retrievedAnswers) convertedAnswers.thu_baseline = retrievedAnswers.thu_baseline;
    if ('fri_baseline' in retrievedAnswers) convertedAnswers.fri_baseline = retrievedAnswers.fri_baseline;
    if ('sat_baseline' in retrievedAnswers) convertedAnswers.sat_baseline = retrievedAnswers.sat_baseline;
    if ('sun_baseline' in retrievedAnswers) convertedAnswers.sun_baseline = retrievedAnswers.sun_baseline;
    if ('totalDrinksBaseline' in retrievedAnswers) convertedAnswers.totalDrinksBaseline = retrievedAnswers.totalDrinksBaseline;
    if ('totalDryDaysBaseline' in retrievedAnswers) convertedAnswers.totalDryDaysBaseline = retrievedAnswers.totalDryDaysBaseline;
    if ('drinkCost' in retrievedAnswers) convertedAnswers.drinkCost = retrievedAnswers.drinkCost;
    if ('concern_level' in retrievedAnswers) convertedAnswers.concern_level = retrievedAnswers.concern_level;
    if ('targetTotalDrinks' in retrievedAnswers) convertedAnswers.targetTotalDrinks = retrievedAnswers.targetTotalDrinks;
    if ('targetTotalDryDays' in retrievedAnswers) convertedAnswers.targetTotalDryDays = retrievedAnswers.targetTotalDryDays;
    if (retrievedAnswers.pronouns) convertedAnswers.pronouns = retrievedAnswers.pronouns;
    if (retrievedAnswers.endGoal) convertedAnswers.endGoal = retrievedAnswers.endGoal;
    if (retrievedAnswers.caloriesAvoided) convertedAnswers.caloriesAvoided = retrievedAnswers.caloriesAvoided;
    if (retrievedAnswers.dollarsSaved) convertedAnswers.dollarsSaved = retrievedAnswers.dollarsSaved;
    if (retrievedAnswers.extraNightsOfSleep) convertedAnswers.extraNightsOfSleep = retrievedAnswers.extraNightsOfSleep;
    if (retrievedAnswers.ideal_outcome) convertedAnswers.ideal_outcome = retrievedAnswers.ideal_outcome;
    if (retrievedAnswers.negative_consequences) convertedAnswers.negative_consequences = retrievedAnswers.negative_consequences;
    if (retrievedAnswers.challenge_controlling) convertedAnswers.challenge_controlling = retrievedAnswers.challenge_controlling;
    if (retrievedAnswers.height) convertedAnswers.height = retrievedAnswers.height;
    if (retrievedAnswers.weight) convertedAnswers.weight = retrievedAnswers.weight;
    if (retrievedAnswers.state) convertedAnswers.state = retrievedAnswers.state;
    if (retrievedAnswers.recommendedPlanKey) convertedAnswers.recommendedPlanKey = retrievedAnswers.recommendedPlanKey;
    if (retrievedAnswers.chosenPlanKey) convertedAnswers.chosenPlanKey = retrievedAnswers.chosenPlanKey as MEDICATION_PLAN_KEY;

    return convertedAnswers;
};

export const payloadFormatter = (ref: string, rawValue: any, formId: string) => {
    let value: any;

    switch (ref) {
    case 'gender':
    case 'age_range': {
        value = {
            label: rawValue
        };
        break;
    }
    case 'top_goal': {
        value = {
            label: GOAL_CHOICES.find(goal => goal.key === rawValue)?.legacyTitle
        };
        break;
    }
    case 'freq_of_effects': {
        value = {
            label: EFFECT_FREQUENCIES.find(freq => freq.key === rawValue)?.subtitle
        };
        break;
    }
    case 'other_goals': {
        const selections = GOAL_CHOICES.map(goal => {
            if (rawValue.includes(goal.key)) {
                return {
                    label: goal.legacyTitle,
                    selected: true
                };
            } else {
                return {
                    label: goal.legacyTitle,
                    selected: false
                };
            }
        });
        value = {
            ...selections
        };
        break;
    }
    case 'focus_areas': {
        const areas = FOCUS_AREAS.map(area => {
            if (rawValue.includes(area.key)) {
                return {
                    label: `${area.title}: ${area.subtitle}`.replace(/\./g, ''),
                    selected: true
                };
            } else {
                return {
                    label: `${area.title}: ${area.subtitle}`.replace(/\./g, ''),
                    selected: false
                };
            }
        });
        value = {
            ...areas
        };
        break;
    }
    case 'concern_level': {
        value = parseInt(rawValue);
        break;
    }
    case 'abcfitnessdryjanuary-2025-challenge_identifier':
    case 'dryish-january-2025-challenge_identifier':
    case 'ucbdryjanuary-2025-challenge_identifier': {
        const {
            key, subtitle, preferenceKey
        } = DRY_JAN_CHALLENGES.find(({
            key
        }) => key === rawValue);
        value = {
            label: subtitle,
            value: key,
            key: preferenceKey
        };
        break;
    }
    case 'dryish-january-2026-challenge_identifier': {
        const {
            key, subtitle, preferenceKey
        } = DRY_JAN_2026_CHALLENGES.find(({
            key
        }) => key === rawValue);
        value = {
            label: subtitle,
            value: key,
            key: preferenceKey
        };
        break;
    }
    case 'soberishmom-dryjan-2025-challenge_identifier': {
        const {
            key, subtitle, preferenceKey
        } = SOBERISH_MOM_DRYJAN_CHALLENGES.find(({
            key
        }) => key === rawValue);
        value = {
            label: subtitle,
            value: key,
            key: preferenceKey
        };
        break;
    }
    case 'soberishmom-dryjan-2026-challenge_identifier': {
        const {
            key, subtitle, preferenceKey
        } = SOBERISH_MOM_DRYJAN_2026_CHALLENGES.find(({
            key
        }) => key === rawValue);
        value = {
            label: subtitle,
            value: key,
            key: preferenceKey
        };
        break;
    }
    case 'soberishmom-challenge_identifier': {
        const {
            key, subtitle, preferenceKey
        } = SOBERISH_MOM_CHALLENGES.find(({
            key
        }) => key === rawValue);
        value = {
            label: subtitle,
            value: key,
            key: preferenceKey
        };
        break;
    }
    case 'zumba-2025-04-challenge_identifier': {
        const {
            key, subtitle, preferenceKey
        } = ZUMBA_CHALLENGES.find(({
            key
        }) => key === rawValue);
        value = {
            label: subtitle,
            value: key,
            key: preferenceKey
        };
        break;
    }
    case 'better-drinkers-2025-challenge_identifier': {
        const {
            key, subtitle, preferenceKey
        } = BETTER_DRINKERS_CHALLENGES.find(({
            key
        }) => key === rawValue);
        value = {
            label: subtitle,
            value: key,
            key: preferenceKey
        };
        break;
    }
    case 'soberish-october-2025-challenge_identifier': {
        const {
            key, subtitle, preferenceKey
        } = SOBERISH_OCTOBER_2025_CHALLENGES.find(({
            key
        }) => key === rawValue);
        value = {
            label: subtitle,
            value: key,
            key: preferenceKey
        };
        break;
    }
    default: {
        value = rawValue;
        break;
    }
    }

    return {
        formId,
        ref,
        value,
    };
};

export const medPayloadFormatter = (ref: string, rawValue: any, formId: string) => {
    let value: any;

    switch (ref) {
    case 'top_goal': {
        value = {
            label: MED_FIRST_GOAL_CHOICES.find(goal => goal.key === rawValue)?.legacyTitle
        };
        break;
    }
    case 'other_goals': {
        const selections = MED_FIRST_GOAL_CHOICES.map(goal => {
            if (rawValue.includes(goal.key)) {
                return {
                    label: goal.legacyTitle,
                    selected: true
                };
            } else {
                return {
                    label: goal.legacyTitle,
                    selected: false
                };
            }
        });
        value = {
            ...selections
        };
        break;
    }
    default: {
        value = rawValue;
        break;
    }
    }

    return {
        formId,
        ref,
        value,
    };
};

export const didPassCondition = (module: any, answers: MATIntakeAnswers, shouldRedirect: boolean, matFormContext?: MATFormContextValue) => {
    const {
        filterType, moduleId, value
    } = module.condition;
    const forwardJump = module?.forwardJump ? parseInt(module.forwardJump) : 1;
    const backwardJump = module?.backwardJump ? parseInt(module.backwardJump) : 1;

    const answer = answers[moduleId];
    if (filterType === 'is-equal-to') {
        if (!answer || ((Array.isArray(answer) ? JSON.stringify(answer) : answer) !== value)) {
            delete answers[module.id];

            if (shouldRedirect) {
                matFormContext.forcedUpdate = true;
                if (matFormContext.screenDirection === 'left') {
                    matFormContext.goNext(forwardJump);
                } else {
                    matFormContext.goBack(backwardJump);
                }
            }

            return false;
        }
    } else if (filterType === 'is-not-equal-to') {
        if (!answer || ((Array.isArray(answer) ? JSON.stringify(answer) : answer) === value)) {
            delete answers[module.id];

            if (shouldRedirect) {
                matFormContext.forcedUpdate = true;
                if (matFormContext.screenDirection === 'left') {
                    matFormContext.goNext(forwardJump);
                } else {
                    matFormContext.goBack(backwardJump);
                }
            }

            return false;
        }
    } else if (filterType === 'contains') {
        if (!answer || !(answer as string[]).includes(value)) {
            delete answers[module.id];

            if (shouldRedirect) {
                matFormContext.forcedUpdate = true;
                if (matFormContext.screenDirection === 'left') {
                    matFormContext.goNext(forwardJump);
                } else {
                    matFormContext.goBack(backwardJump);
                }
            }

            return false;
        }
    } else if (filterType === 'does-not-contain') {
        if (!answer || (answer as string[]).includes(value)) {
            delete answers[module.id];

            if (shouldRedirect) {
                matFormContext.forcedUpdate = true;
                if (matFormContext.screenDirection === 'left') {
                    matFormContext.goNext(forwardJump);
                } else {
                    matFormContext.goBack(backwardJump);
                }
            }

            return false;
        }
    }

    return true;
};

export const convertFormAnswersToOpenloopAnswers = (
    answers: MATIntakeAnswers,
    form: any,
    matFormContext: MATFormContextValue
): finalizeAnswerPayload[] => {
    const openloopAnswers: finalizeAnswerPayload[] = [];
    for (const formModuleId in answers) {
        const module = form.modules.find((m: any) => m.id === formModuleId);
        if (!module) continue;
        if ('condition' in module && !didPassCondition(module, matFormContext.answers, false, matFormContext)) {
            continue;
        }

        const answer: finalizeAnswerPayload = {
            formModuleId,
            answer: answers[formModuleId],
            label: module?.label
        };
        if ('key' in module) {
            if (module.key === 'medication') {
                answer.answer = answer.answer.map(a => ({
                    ...a,
                    active: true
                }));
            } else if (module.key === 'allergy') {
                answer.answer = answer.answer.map(a => ({
                    ...a,
                    category: 'allergy'
                }));
            }
            answer.key = module.key;
        }
        openloopAnswers.push(answer);
    }
    return openloopAnswers;
};

export const convertOpenLoopAnswersToFormAnswers = (formContext: MATFormContextValue, answers: finalizeAnswerPayload[]) => {
    answers.forEach((answer) => {
        if ([formContext.prescriptionsId, formContext.allergiesId].includes(answer.formModuleId) && !Array.isArray(answer.answer)) {
            formContext.answers[answer.formModuleId] = [answer.answer];
            return;
        }
        formContext.answers[answer.formModuleId] = answer.answer;
        if (answer.key === 'medication') {
            formContext.answers[answer.formModuleId] = (formContext.answers[answer.formModuleId] as { name: string, dosage: string, frequency: string, active: boolean }[]).map(a => ({
                name: a.name,
                dosage: a.dosage,
                frequency: a.frequency
            }));
        } else if (answer.key === 'medication-timelines') {
            formContext.answers[answer.formModuleId] = (formContext.answers[answer.formModuleId] as { name: string, dosage: string, frequency: string, active: boolean, dateRange: string }[]).map(a => ({
                name: a.name,
                dosage: a.dosage,
                frequency: a.frequency,
                dateRange: a.dateRange
            }));
        } else if (answer.key === 'surgeries') {
            formContext.answers[answer.formModuleId] = (formContext.answers[answer.formModuleId] as { type: string, dateRange: string }[]).map(a => ({
                type: a.type,
                dateRange: a.dateRange
            }));
        }
    });
};

type DOBAnswer = {
    day: string,
    month: string,
    year: string
}

export const completeMATIntakeForm = async (
    MATFormContext: MATFormContextValue,
    user: any,
    cookies: any,
    form: any,
    isRefillFlow: boolean,
    router,
    isSyncVisitRequired = false,
    dobAnswer?: DOBAnswer
) => {
    try {
        if (!MATFormContext.isFormFinalized) {
            const answers = convertFormAnswersToOpenloopAnswers(
                MATFormContext.answers as MATIntakeAnswers,
                form,
                MATFormContext
            );
            const redirectFormModule = form.modules.find(m => m.key === 'form-submission-redirect');
            const dobModule = form.modules.find(m => m.key === 'dob');

            // ensure DOB exists
            if (!isRefillFlow && !answers?.some(a => a.formModuleId === dobModule?.id) && dobAnswer) {
                const answer: finalizeAnswerPayload = {
                    formModuleId: dobModule?.id,
                    answer: dobAnswer,
                    label: dobModule?.label,
                    key: 'dob'
                };
                answers.push(answer);
            }

            if (!answers?.some(a => a.formModuleId === redirectFormModule.id)) {
                /**
                 * TODO: Have key property that gets passed to backend and is parsed and "match" with the correct
                 * module based on key - similar to how we process and format the AVS (encounter note)
                 */
                const ctfModalityModuleId = '31804113';
                const ctfConditionModuleId = '31804121';
                const patientIntakeModuleId = '31804114';

                answers.push({
                    formModuleId: redirectFormModule.id,
                    key: 'form-submission-redirect',
                    label: redirectFormModule.label,
                    redirectFormId: redirectFormModule.redirectFormId,
                    redirectFormName: redirectFormModule.redirectFormName,
                    answer: [
                        {
                            formModuleId: ctfModalityModuleId,
                            type: 'simple',
                            answer: isSyncVisitRequired ? 'sync_visit' : 'async_visit'
                        }, {
                            formModuleId: ctfConditionModuleId,
                            type: 'simple',
                            answer: 'Alcohol Cessation'
                        }, {
                            formModuleId: patientIntakeModuleId,
                            type: 'dump'
                        }
                    ]
                });
            }
            const openloopFormId = mapFormIdToOpenloopFormId(MATFormContext.formId);
            if (!isRefillFlow) {
                const formKey = isNewMedFirstFunnel(MATFormContext.formId)
                    ? 'ss_combined_intake'
                    : 'ss_intake';
                const intakeFinalizeResponse = await post(`openloop/patient/forms/intake/finalize/${formKey}`, {
                    formId: openloopFormId,
                    userId: user.id,
                    answers
                } as finalizePayload);

                if (intakeFinalizeResponse?.message) {
                    dataDogLogger('error', 'Failed to finalize MAT intake form', {
                        rawData: {
                            response: intakeFinalizeResponse
                        }
                    });
                    return {
                        error: 'intake'
                    };
                }
                if (user.flowType === FlowType.MED_FIRST || user.flowType === FlowType.MED_FIRST_WINBACK) {
                    const url = getCurrentUrlPath() || `https://app.joinsunnysidemed.com/mf/intake/${MATFormContext.formId}/${MATFormContext.screenIndex}`;
                    const referrer = getReferrerPath();
                    tiktokEvent({
                        pixelAudience: TiktokPixelAudience.MED,
                        event_name: TikTokEvent.SUBMIT_FORM,
                        user,
                        url,
                        referrer,
                        cookies
                    });
                }
            } else {
                const refillFinalizeResponse = await post('openloop/patient/forms/refill/finalize', {
                    formId: openloopFormId,
                    userId: user.id,
                    answers,
                    redirectFormModule
                } as finalizePayload);

                if (refillFinalizeResponse?.message) {
                    dataDogLogger('error', 'Failed to finalize MAT refill form', {
                        rawData: {
                            response: refillFinalizeResponse
                        }
                    });
                    return {
                        error: 'intake'
                    };
                }
            }

            MATFormContext.isFormFinalized = true;
        }

        if (!isRefillFlow) {
            const response = await post(`stripe/pending-subscription/finalize/${PlanKeyEnum.SS_MAT_NALTREX}?provider=${StripeProviderEnum.OPENLOOP}`);
            if (response?.message) {
                dataDogLogger('error', `Failed to finalize ${MATFormContext.flowType === 'med_first' ? 'med first' : 'active member'} provider intake subscription`, {
                    rawData: {
                        response
                    }
                });
                router.push(MATFormContext.flowType === 'med_first' ? `/mf/payment/error?formId=${MATFormContext.formId}` : `/medication/intake/payment/error?formId=${MATFormContext.formId}${funnelOverrideQuery()}`);
                return {
                    error: 'payment'
                };
            } else {
                router.push(MATFormContext.flowType === 'med_first' ? `/mf/payment/success?formId=${MATFormContext.formId}` : `/medication/intake/payment/success?formId=${MATFormContext.formId}`);
                return {
                    error: null
                };
            }
        }

        return {
            error: null
        };
    } catch (error: any) {
        dataDogLogger('error', 'Failed to finalize MAT intake form', {
            rawData: {
                error
            }
        });
    } finally {
        MATFormContext.attemptingFinalize = false;
    }
};

export const changeUrl = (formContext: FormContextValue, router: NextRouter, preventHistoryHook: [any, Dispatch<any>]) => {
    if (formContext.screenIndex === undefined || formContext.screenIndex === null) return;

    const [preventHistoryOverride, setPreventHistoryOverride] = preventHistoryHook;

    // The path carries the slug, so only the rest of the query (such as `override=true`) rides along
    let path = '';
    switch (formContext.type) {
    case 'signup':
        path = 'diagnostic';
        break;
    case 'med prequal':
        path = 'medication/diagnostic';
        break;
    case 'med patient intake':
        path = 'medication/intake';
        break;
    case 'med patient refill':
        path = 'medication/refill';
        break;
    case 'med first prequal': {
        path = 'mf/diagnostic';
        break;
    }
    case 'med first intake': {
        path = 'mf/intake';
        break;
    }
    default:
        path = 'diagnostic';
        break;
    }

    if (!preventHistoryOverride) {
        router.push({
            pathname: `/${path}/${formContext.formId}/${formContext.screenIndex}`,
            query: omit(router.query, 'slug')
        }, null, {
            shallow: true
        });
    } else {
        router.replace({
            pathname: `/${path}/${formContext.formId}/${formContext.screenIndex}`,
            query: omit(router.query, 'slug')
        }, null, {
            shallow: true
        });
    }
    setPreventHistoryOverride(false);
};

export const fireTrackingEvents = (formContext: FormContextValue, trackingName: string, cookies: any, attributes = {}) => {
    const eventName = `${formContext.type}: landed on ${trackingName}`;
    if (trackingName === 'diagnostic') {
        gaClientEvent({
            action: 'Page',
            category: 'Land',
            label: eventName,
            value: '',
        });
    }

    ampLogEvent(
        eventName,
        {
            formId: formContext.formId,
            ...attributes
        },
        cookies
    );

    if (!formContext.startTime) return;

    const endTime = new Date().getTime();
    const diff = endTime - formContext.startTime;

    dataDogLogger(
        'info',
        `${formContext.type} screen ${trackingName} rendered in ${diff}ms`,
        {
            frontendMetric: diff,
            url: trackingName,
            rawData: {
                formId: formContext.formId
            }
        }
    );
    formContext.startTime = null;
};

export type Plan = {
    key?: MEDICATION_PLAN_KEY,
    name?: string,
    description?: string,
    price?: number,
    bundledPrice?: number
    priceBackgroundColor?: string,
    color?: string,
    image?: string,
    imageStyle?: React.CSSProperties,
    eligiblePlans?: MEDICATION_PLAN_KEY[]
}

export const getPlan = (planKey: MEDICATION_PLAN_KEY): Plan => {
    switch (planKey) {
    case MEDICATION_PLAN_KEY.NALTREXONE:
        return {
            key: MEDICATION_PLAN_KEY.NALTREXONE,
            name: 'Naltrexone Only Program',
            description: 'Our lowest price option offering the standard 50mg dose of naltrexone.',
            price: 99,
            bundledPrice: 108,
            priceBackgroundColor: theme.palette.med.yellow,
            color: theme.palette.med.blue,
            image: '/img/med-first/naltrexonePillApp.png'
        };
    case MEDICATION_PLAN_KEY.GLP1_FULL:
        return {
            key: MEDICATION_PLAN_KEY.GLP1_FULL,
            name: 'Semaglutide + Naltrexone Full Dose Program',
            description: 'Our most comprehensive option combining personalized dosing of semaglutide (up to 20mg) and naltrexone (up to 50mg).',
            price: 299,
            bundledPrice: 299,
            priceBackgroundColor: theme.palette.med.blue,
            color: theme.palette.med.yellow,
            image: '/img/med-first/combinationProgramPillApp.png'
        };
    case MEDICATION_PLAN_KEY.GLP1_MICRO:
        return {
            key: MEDICATION_PLAN_KEY.GLP1_MICRO,
            name: 'Semaglutide + Naltrexone Microdose Program',
            description: 'A lower dose and lower priced option combining 2.5mg of Semaglutide with up to 50mg of Naltrexone.',
            price: 199,
            bundledPrice: 199,
            priceBackgroundColor: theme.palette.med.blue,
            color: theme.palette.med.green,
            image: '/img/med-first/combinationProgramPillApp.png'
        };
    default:
        return {
            key: MEDICATION_PLAN_KEY.NALTREXONE,
            name: 'Naltrexone Program',
            description: 'Our lowest price option offering the standard 50mg dose of naltrexone.',
            price: 99,
            bundledPrice: 108,
            priceBackgroundColor: theme.palette.med.yellow,
            color: theme.palette.med.blue,
            image: '/img/med-first/naltrexonePillApp.png'
        };
    }
};

export enum MEDICATION_PLAN_KEY {
    NALTREXONE = 'naltrexone',
    GLP1_MICRO = 'glp1_micro',
    GLP1_FULL = 'glp1_full'
}

export const CHOSEN_PRODUCT_OL_MAP = {
    [MEDICATION_PLAN_KEY.NALTREXONE]: 'naltrexone_only',
    [MEDICATION_PLAN_KEY.GLP1_MICRO]: 'naltrexone_sema_micro_dose',
    [MEDICATION_PLAN_KEY.GLP1_FULL]: 'naltrexone_sema_full_dose'
};

export const getRecommendedPlan = (formId: string, answers: any) => {
    const weight = parseFloat(answers?.weight);
    const height = parseInt(answers?.height);
    const {
        state,
        other_goals: goals,
        negative_consequences,
        challenge_controlling
    } = answers;
    const qualifyingGoals = new Set(['health', 'weight', 'heart_disease', 'liver_disease', 'fitness']);
    const hasReportedStruggling = negative_consequences === 'true' || challenge_controlling === 'true';
    const hasQualifyingGoal = goals?.some(goal => qualifyingGoals.has(goal));

    if (!weight || !height || typeof weight !== 'number' || typeof height !== 'number') {
        return {
            recommendedPlanKey: MEDICATION_PLAN_KEY.NALTREXONE,
            recommendedPlan: {
                ...getPlan(MEDICATION_PLAN_KEY.NALTREXONE),
                eligiblePlans: [MEDICATION_PLAN_KEY.NALTREXONE]
            }
        };
    }

    const bmi = weight * 703 / height / height;

    // naltrexone only
    let recommendedPlanKey = MEDICATION_PLAN_KEY.NALTREXONE;

    switch (formId) {
    case naltrexoneFirstV2RecommendationDiagnosticFormId:
        recommendedPlanKey = MEDICATION_PLAN_KEY.NALTREXONE;
        break;
    case glp1DiagnosticFormId:
        if (hasReportedStruggling && state !== 'Louisiana') {
            if (bmi >= 25) {
                recommendedPlanKey = MEDICATION_PLAN_KEY.GLP1_FULL;
            } else if (bmi >= 20) {
                recommendedPlanKey = MEDICATION_PLAN_KEY.GLP1_MICRO;
            }
        }
        break;
    case genericSunnysideMedDiagnosticFormId:
    case genericAdSafeSunnysideMedDiagnosticFormId:
    case naltrexoneV2RecommendationDiagnosticFormId:
        if (hasReportedStruggling && hasQualifyingGoal && state !== 'Louisiana') {
            if (bmi >= 25) {
                recommendedPlanKey = MEDICATION_PLAN_KEY.GLP1_FULL;
            } else if (bmi >= 20) {
                recommendedPlanKey = MEDICATION_PLAN_KEY.GLP1_MICRO;
            }
        }
        break;
    default:
        recommendedPlanKey = MEDICATION_PLAN_KEY.NALTREXONE;
        break;
    }
    
    const eligiblePlans = getEligiblePlans(answers);

    return {
        recommendedPlanKey,
        recommendedPlan: {
            ...getPlan(recommendedPlanKey),
            eligiblePlans
        }
    };
};

export const getEligiblePlans = (answers: any) => {
    const weight = parseFloat(answers?.weight);
    const height = parseInt(answers?.height);

    if (!weight || !height || typeof weight !== 'number' || typeof height !== 'number') return [MEDICATION_PLAN_KEY.NALTREXONE];

    const bmi = weight * 703 / height / height;

    if (answers?.state !== 'Louisiana') {
        if (bmi >= 25) {
            return [MEDICATION_PLAN_KEY.GLP1_FULL, MEDICATION_PLAN_KEY.GLP1_MICRO, MEDICATION_PLAN_KEY.NALTREXONE];
        } else if (bmi >= 20) {
            return [MEDICATION_PLAN_KEY.GLP1_MICRO, MEDICATION_PLAN_KEY.NALTREXONE];
        }
        return [MEDICATION_PLAN_KEY.NALTREXONE];
    }
    return [MEDICATION_PLAN_KEY.NALTREXONE];
};

export const hasConsentedToTerms = async (consentAgreements: any[]) => {
    const latestAgreements = await get('user-consent/latest-sunnyside-terms-agreements');

    let hasAllRequiredConsent = false;
    if (latestAgreements && !latestAgreements.error) {
        hasAllRequiredConsent = Object.entries(latestAgreements).every(([agreement, versions]) => {
            return consentAgreements.some((consent: any) => {
                if (Array.isArray(versions)) {
                    return consent.agreement === agreement && versions.includes(consent.version);
                } else {
                    return consent.agreement === agreement && consent.version === versions;
                }
            });
        });
    }

    return hasAllRequiredConsent;
};

/**
 * An `?override=true` link lets a member who has been through the upsell funnel before go through it again, so the
 * flag rides along on every hop of it: checkout, address confirmation, intake and the payment pages.
 */
export const isFunnelOverride = (): boolean => (
    typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('override') === 'true'
);

export const funnelOverrideQuery = (): string => (isFunnelOverride() ? '&override=true' : '');

/**
 * TOOD: Update to be dynamic based on pricing data + add pricing endpoint to get data to populate
 * page.
 *
 * TEMP COUPONS FOR TESTING ADDED REMOVE UPON RELEASE AND ADD BETTER TESTING LOGIC
 */
export const createCheckout = async (isBundle: boolean, formId: string): Promise<{ url: string }> => {
    const ENVIRONMENT = process.env.NEXT_PUBLIC_NENV;
    const pendingSubscription = isBundle ? {
        priceId: ENVIRONMENT === 'production'
            ? ['price_1RCM9kPASHK73jybLMoTpamn', 'price_1RlGVyPASHK73jybZSU1ZEsB']
            : ['price_1RCMDOPASHK73jybXUFTpsFe', 'price_1RqEzAPASHK73jybTQJMScpc'],
        coupon: 'ndt'
    } : {
        priceId: ENVIRONMENT === 'production' ? 'price_1RCM9kPASHK73jybLMoTpamn' : 'price_1RCMDOPASHK73jybXUFTpsFe',
        // coupon: ENVIRONMENT === 'production' ? '99_SUB_2788208376' : null
    };
    const response = await post(`stripe/checkout?provider=${StripeProviderEnum.OPENLOOP}`, {
        prices: {
            oneTime: [
                {
                    priceId: ENVIRONMENT === 'production' ? 'price_1RBJSEPASHK73jybcoOgQGv1' : 'price_1RBJKuPASHK73jyb3phymiwu'
                }
            ]
        },
        pendingSubscription,
        successUrl: window ? window.location.protocol + '//' + window.location.host + `/medication/address-confirm?session_id={CHECKOUT_SESSION_ID}&type=intake&formId=${formId}${funnelOverrideQuery()}` : '',
        cancelUrl: window ? window.location.href : '',
        trialDays: 0,
        shippingAddressCollection: true,
        // coupons: ENVIRONMENT === 'production' ? ['99_CONSULT_2788208376'] : null
    });
    return response as { url: string };
};

export const canRequestRefill = (subscriptionRenewalDate: string) => {
    return spacetime(subscriptionRenewalDate).subtract(REFILL_RENEWAL_WINDOW_DAY_COUNT, 'day').isBefore(spacetime.now());
};

export const hasSubmittedRecentRefill = (refillFormCreatedAt: string) => {
    if (!refillFormCreatedAt) return false;
    return spacetime(new Date(refillFormCreatedAt)).isAfter(spacetime.now().subtract(REFILL_BUFFER_DAY_COUNT, 'day'));
};

// The recommendation diagnostic answers that are saved to the server as they're given, for the intake to read later
const MED_RECOMMENDATION_ANSWER_KEYS = [
    'ideal_outcome',
    'top_goal',
    'other_goals',
    'negative_consequences',
    'challenge_controlling',
    'height',
    'weight',
    'state',
    'recommendedPlanKey',
    'chosenPlanKey'
];

export const saveMedRecommendationAnswers = (partialAnswers: Record<string, any>, formId: string) => {
    if (!isNewMedFirstFunnel(formId)) return;

    MED_RECOMMENDATION_ANSWER_KEYS.forEach(key => {
        if (!partialAnswers[key]) return;

        const value = key === 'other_goals'
            ? (partialAnswers.other_goals as string[]).filter(goal => goal !== partialAnswers.top_goal)
            : partialAnswers[key];
        post('forms/partial-answer', medPayloadFormatter(key, value, formId));
    });
};

export const redirectToMissingRecommendationQuestions = (diagnosticFormContext: MedFirstDiagnosticFormContextValue, currentScreenIndex: number, router: NextRouter) => {
    let redirect = false;
    let offset = 9;
    let newScreenIndex = currentScreenIndex;
    const recommendationScreenIndex = diagnosticFormContext.sections.reduce((t, s) => {
        return t + (s.length - 1);
    }, 0);
    // Upsell members get a name screen before state, which puts every question before it one screen further back
    const hasNameScreen = diagnosticFormContext.type === 'med prequal';
    const nameScreenCount = hasNameScreen ? 1 : 0;
    const isMissingName = hasNameScreen && (!diagnosticFormContext.answers.firstName || !diagnosticFormContext.answers.lastName);
    if (diagnosticFormContext.answers.chosenPlanKey) {
        // A resumed upsell member with a plan still needs a name before checkout
        offset = isMissingName ? 2 : 0;
        redirect = true;
    } else {
        if (!diagnosticFormContext.answers.ideal_outcome && currentScreenIndex > (recommendationScreenIndex - 7 - nameScreenCount)) {
            offset = 7 + nameScreenCount;
            redirect = true;
        } else if ((!diagnosticFormContext.answers.top_goal || !diagnosticFormContext.answers.other_goals?.length) && currentScreenIndex > (recommendationScreenIndex - 6 - nameScreenCount)) {
            offset = 6 + nameScreenCount;
            redirect = true;
        } else if (!diagnosticFormContext.answers.negative_consequences && currentScreenIndex > (recommendationScreenIndex - 5 - nameScreenCount)) {
            offset = 5 + nameScreenCount;
            redirect = true;
        } else if (!diagnosticFormContext.answers.challenge_controlling && currentScreenIndex > (recommendationScreenIndex - 4 - nameScreenCount)) {
            offset = 4 + nameScreenCount;
            redirect = true;
        } else if (!diagnosticFormContext.answers.height && currentScreenIndex > (recommendationScreenIndex - 3 - nameScreenCount)) {
            offset = 3 + nameScreenCount;
            redirect = true;
        } else if (!diagnosticFormContext.answers.weight && currentScreenIndex > (recommendationScreenIndex - 2 - nameScreenCount)) {
            offset = 2 + nameScreenCount;
            redirect = true;
        } else if (isMissingName && currentScreenIndex > (recommendationScreenIndex - 2)) {
            offset = 2;
            redirect = true;
        } else if (!diagnosticFormContext.answers.state && currentScreenIndex > (recommendationScreenIndex - 1)) {
            offset = 1;
            redirect = true;
        }
    }

    if (redirect) {
        newScreenIndex = recommendationScreenIndex - offset;
        // Upsell members take the same diagnostic under /medication
        const path = diagnosticFormContext.type === 'med prequal' ? 'medication/diagnostic' : 'mf/diagnostic';
        router.query.slug = [diagnosticFormContext.formId, newScreenIndex.toString()];
        router.replace({
            pathname: `/${path}/${diagnosticFormContext.formId}/${newScreenIndex}`,
            query: omit(router.query, 'slug')
        }, null, {
            shallow: true
        });
    }

    return newScreenIndex;
};

/**
 * Checks whether this funnel is one of the legacy funnels
 * @param formId 
 * @returns whether or not this is a legacy funnel
 */
export const isLegacyMedFirstFunnel = (formId: string) => {
    if ([
        naltrexoneOnlyDiagnosticFormId,
        naltrexoneOnlyV2DiagnosticFormId
    ].includes(formId)) return true;

    return false;
};

/**
 * Checks whether this funnel is one of the new recommendation funnels
 * @param formId 
 * @returns whether or not this is a new recommendation funnel
 */
export const isNewMedFirstFunnel = (formId: string) => {
    if ([
        naltrexoneFirstV2RecommendationDiagnosticFormId,
        naltrexoneV2RecommendationDiagnosticFormId,
        glp1DiagnosticFormId,
        genericSunnysideMedDiagnosticFormId,
        genericAdSafeSunnysideMedDiagnosticFormId
    ].includes(formId)) return true;

    return false;
};

/**
 * Checks whether this funnel sends events to the legacy med pixels
 * @param formId 
 * @returns whether or not this funnel is instrumented on legacy med pixels
 */
export const usesLegacyMedPixel = (formId: string) => {
    if ([
        naltrexoneOnlyDiagnosticFormId,
        naltrexoneOnlyV2DiagnosticFormId,
        naltrexoneFirstV2RecommendationDiagnosticFormId,
        naltrexoneV2RecommendationDiagnosticFormId,
        genericAdSafeSunnysideMedDiagnosticFormId
    ].includes(formId)) return true;

    return false;
};

/**
 * Checks whether this funnel sends events to the new med pixels
 * @param formId 
 * @returns whether or not this funnel is instrumented on new med pixels
 */
export const usesNewMedPixel = (formId: string) => {
    if ([
        glp1DiagnosticFormId,
        genericSunnysideMedDiagnosticFormId
    ].includes(formId)) return true;

    return false;
};

/**
 * Checks whether this funnel uses new styles
 * @param formId 
 * @returns whether or not this funnel uses the new med styles
 */
export const hasNewMedFirstStyles = (formId: string) => {
    if ([
        naltrexoneOnlyV2DiagnosticFormId,
        naltrexoneFirstV2RecommendationDiagnosticFormId,
        naltrexoneV2RecommendationDiagnosticFormId,
        glp1DiagnosticFormId,
        genericSunnysideMedDiagnosticFormId,
        genericAdSafeSunnysideMedDiagnosticFormId
    ].includes(formId)) return true;

    return false;
};

export const getPlanPriceValue = (planKey: MEDICATION_PLAN_KEY) => {
    switch (planKey) {
    case MEDICATION_PLAN_KEY.NALTREXONE:
        return 297;
    case MEDICATION_PLAN_KEY.GLP1_FULL:
        return 299;
    case MEDICATION_PLAN_KEY.GLP1_MICRO:
        return 199;
    default:
        return 297;
    }
};

export const checkAnswersForSyncVisitRequirement = (diagnosticFormContext: MATFormContextValue, birthDate: string) => {
    const ENVIRONMENT = process.env.NEXT_PUBLIC_NENV;
    const chosenProductAnswer = diagnosticFormContext.answers[ENVIRONMENT === 'production' ? '39354684' : '19525750'];

    if (!chosenProductAnswer) return false;

    const patientIsOver64 = spacetime(birthDate).diff(spacetime.now()).years > 64;
    const patientIsUnder75 = spacetime(birthDate).diff(spacetime.now()).years < 75;
    const bloodPressureAnswer = diagnosticFormContext.answers[ENVIRONMENT === 'production' ? '39319363' : '19516761'];
    const existingConditions1Answer1 = diagnosticFormContext.answers[ENVIRONMENT === 'production' ? '39319333' : '19516738'];
    const existingConditions1Answer2 = diagnosticFormContext.answers[ENVIRONMENT === 'production' ? '39354696' : '19525751'];
    const existingConditions1Answer = `${existingConditions1Answer1}, ${existingConditions1Answer2}`;
    const existingConditions2Answer = diagnosticFormContext.answers[ENVIRONMENT === 'production' ? '39319335' : '19516740'];
    const formulationBenefitsAnswer = diagnosticFormContext.answers[ENVIRONMENT === 'production' ? '39359667' : '19526721'];

    const hasLiverDisease = existingConditions1Answer?.includes('Severe liver disease (including cirrhosis or any other severe liver disease)')
        || (existingConditions2Answer as string)?.includes('Liver disease (not considered severe), including fatty liver');
    const hasType2DiabetesNoInsulin = existingConditions1Answer?.includes('Type 2 diabetes (not on insulin)');
    const hasKidneyDisease = existingConditions1Answer?.includes('End-stage kidney disease (on or about to be on dialysis)')
        || (existingConditions2Answer as string)?.includes('Kidney disease');
    const hasHighBloodPressure = bloodPressureAnswer === '140-159/90-99 (High Stage 2)';
    const requestedProviderMeeting = (formulationBenefitsAnswer as string)?.includes('I\'m not sure - I\'d like to discuss formulation options with a clinician via a live virtual consult');

    if (requestedProviderMeeting) return true;
    
    if (patientIsOver64 && patientIsUnder75) {
        return (
            hasHighBloodPressure
            || hasType2DiabetesNoInsulin
            || hasKidneyDisease
            || hasLiverDisease
        );
    }

    return false;
};

export const getLastMedicationUseModuleId = (formId) => {
    const ENVIRONMENT = process.env.NEXT_PUBLIC_NENV;
    switch (formId) {
    case naltrexoneOnlyRefillFormId:
        return ENVIRONMENT === 'production' ? '37293433' : '19267737';
    case naltrexoneOnlyV2RefillFormId:
        return ENVIRONMENT === 'production' ? '39367517' : '19526491';
    case glp1RefillFormId:
        return ENVIRONMENT === 'production' ? '39367544' : '19526515';
    default:
        return;
    }
};

export const getRefillChosenProductModuleId = (formId) => {
    const ENVIRONMENT = process.env.NEXT_PUBLIC_NENV;
    switch (formId) {
    case naltrexoneOnlyV2RefillFormId:
        return ENVIRONMENT === 'production' ? '39367515' : '19529692';
    case glp1RefillFormId:
        return ENVIRONMENT === 'production' ? '39367542' : '19529691';
    default:
        return;
    }
};

const getSituationChangeModuleId = (formId) => {
    const ENVIRONMENT = process.env.NEXT_PUBLIC_NENV;
    switch (formId) {
    case naltrexoneOnlyRefillFormId:
        return ENVIRONMENT === 'production' ? '37294518' : '19267773';
    case naltrexoneOnlyV2RefillFormId:
        return ENVIRONMENT === 'production' ? '39367529' : '19526505';
    case glp1RefillFormId:
        return ENVIRONMENT === 'production' ? '39367558' : '19526527';
    default:
        return;
    }
};

const getExtremeSymptomsModuleId = (formId) => {
    const ENVIRONMENT = process.env.NEXT_PUBLIC_NENV;
    switch (formId) {
    case naltrexoneOnlyRefillFormId:
        return ENVIRONMENT === 'production' ? '37294494' : '19267801';
    case naltrexoneOnlyV2RefillFormId:
        return ENVIRONMENT === 'production' ? '39367527' : '19526503';
    case glp1RefillFormId:
        return ENVIRONMENT === 'production' ? '39367555' : '19526525';
    default:
        return;
    }
};

export const isDisqualifyingAnswer = (formId, answerKey, partialAnswers) => {
    const SITUATION_CHANGE_DISQUALIFYING_ANSWER = 'Current suicidal thoughts and/or prior suicidal attempt';
    const EXTREME_SYMPTOM_DISQAULIFYING_ANSWER = 'Concerning and/or serious mood changes or suicidal thoughts';
    const EXTREME_SYMPTOM_DISQAULIFYING_ANSWER_2 = 'Suicidal thoughts';

    const situationChangeModuleId = getSituationChangeModuleId(formId);
    const extremeSymptomsModuleId = getExtremeSymptomsModuleId(formId);

    return (
        answerKey === situationChangeModuleId
        && partialAnswers[answerKey].includes(SITUATION_CHANGE_DISQUALIFYING_ANSWER)
    ) || (
        answerKey === extremeSymptomsModuleId
        && (
            partialAnswers[answerKey].includes(EXTREME_SYMPTOM_DISQAULIFYING_ANSWER)
            || partialAnswers[answerKey].includes(EXTREME_SYMPTOM_DISQAULIFYING_ANSWER_2)
        )
    );
};

export const mapHealthieAnswerToSunnysideAnswers = (answer: string) => {
    let convertedAnswer = '';

    switch (answer) {
    case '0-5 days ago':
        convertedAnswer = 'daily';
        break;
    case '6-10 days ago':
    case '11-14 days ago':
        convertedAnswer = 'occasionally';
        break;
    case 'More than 2 weeks ago but within the last 4 weeks':
    case 'More than 4 weeks ago':
        convertedAnswer = 'discontinued';
        break;
    case 'I never started taking the medication':
        convertedAnswer = 'never';
        break;
    case 'The side effects are too intense':
        convertedAnswer = 'side-effects';
        break;
    case 'I don\'t like the way it makes me feel':
        convertedAnswer = 'felt-bad';
        break;
    case 'I haven\'t noticed any change in my drinking habits':
        convertedAnswer = 'no-noticeable-change';
        break;
    case 'I have trouble remembering to take the medication':
        convertedAnswer = 'forgetting';
        break;
    case 'I still intend to start but haven\'t gotten to it yet':
        convertedAnswer = 'will-start';
        break;
    case 'I am nervous about potential side effects':
        convertedAnswer = 'nervous';
        break;
    case 'I was not satisfied with the quality of the medication':
        convertedAnswer = 'not-satisfied-with-medication';
        break;
    case 'I was not satisfied with the quality of the care I received from the provider':
        convertedAnswer = 'not-satisfied-with-care';
        break;
    case 'Other':
        convertedAnswer = 'other';
        break;
    case 'Yes, let\'s refill now':
        convertedAnswer = 'now';
        break;
    case 'No, let\'s push out the date':
        convertedAnswer = 'delay';
        break;
    case 'No, I\'m not ready':
    case 'I don\'t plan to refill':
        convertedAnswer = 'later';
        break;
    case 'Yes, please have a coach reach out':
        convertedAnswer = 'yes';
        break;
    case 'No thank you':
        convertedAnswer = 'no';
        break;
    default:
        convertedAnswer = answer;
        break;
    }

    return convertedAnswer;
};
